import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HandoverChain } from '../models/handover-chain.model';
import { Page } from '../models/page.model';
import { TestPlanActivity, TestPlanHandOffRequest } from '../models/test-plan-history.model';

@Injectable({ providedIn: 'root' })
export class TestPlanHistoryService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiBaseUrl}/api/v1/projects`;

  private url(projectId: string, planId: string): string {
    return `${this.base}/${projectId}/test-plans/${planId}`;
  }

  listActivities(projectId: string, planId: string, size: number): Observable<Page<TestPlanActivity>> {
    const params = new HttpParams().set('size', String(size));
    return this.http.get<Page<TestPlanActivity>>(`${this.url(projectId, planId)}/activity`, { params });
  }

  getHandovers(projectId: string, planId: string): Observable<HandoverChain> {
    return this.http.get<HandoverChain>(`${this.url(projectId, planId)}/handovers`);
  }

  handOff(projectId: string, planId: string, request: TestPlanHandOffRequest): Observable<HandoverChain> {
    return this.http.post<HandoverChain>(`${this.url(projectId, planId)}/handovers`, request);
  }

  close(projectId: string, planId: string): Observable<HandoverChain> {
    return this.http.patch<HandoverChain>(`${this.url(projectId, planId)}/handovers/close`, {});
  }

  reopen(projectId: string, planId: string): Observable<HandoverChain> {
    return this.http.patch<HandoverChain>(`${this.url(projectId, planId)}/handovers/reopen`, {});
  }

  skip(projectId: string, planId: string, stageId: string): Observable<HandoverChain> {
    return this.http.patch<HandoverChain>(`${this.url(projectId, planId)}/handovers/${stageId}/skip`, {});
  }
}
